export default {"src":"/_next/static/media/multipleSitesForContactlist.07e599a7.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};